import { memo, useContext, useEffect, useState } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";
import Sample from "./Sample";
import Address from "./Address";

const Customer = memo(() => {
  const { inputs } = useContext(Data);
  const [sofa, setSofa] = useState(null);
  const [sofaData, setSofaData] = useState({});

  useEffect(() => {
    fetch("/api/sofadata.php?type=all")
      .then((res) => res.json())
      .then((data) => {
        const result = {};
        for (const item of data) {
          const { name, size } = item;
          if (result[name]) {
            result[name].push(size);
          } else {
            result[name] = [size];
          }
        }
        setSofaData(result);
      });
  }, []);

  const sofaSelect = (e) => {
    setSofa(() => e.target.value);
  };

  return (
    <>
      {inputs.subject === "ソファについて" ||
      inputs.subject === "生地について" ? (
        <>
          <div className={styles.formMain}>
            <h3 className={`en ${styles.headline}`}>
              SOFA & {inputs.subject === "ソファについて" ? "SIZE" : "MATERIAL"}
              <span>
                製品・
                {inputs.subject === "ソファについて" ? "サイズ" : "カラー"}
                のご選択
              </span>
            </h3>
            <div>
              <div className={styles.selectBox}>
                <p className="bold">ご検討ソファ</p>
                <div>
                  <select name="sofa" onChange={sofaSelect}>
                    <option disabled selected>
                      選択してください
                    </option>
                    <option value="未定">未定</option>
                    {Object.keys(sofaData).map((item, index) => {
                      return (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              {inputs.subject === "ソファについて" ? (
                <>
                  <div className={styles.selectBox}>
                    <p className="bold">ご検討サイズ</p>
                    <div>
                      <select name="size">
                        <option disabled selected>
                          選択してください
                        </option>
                        <option value="未定">未定</option>
                        {sofaData[sofa]?.map((item, index) => {
                          return (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              ) : (
                <Sample />
              )}
            </div>
          </div>
          {inputs.subject === "生地について" && inputs.sample === "あり" ? (
            <Address />
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
});

export default Customer;
